import * as moment from 'moment';
import {
    SharedTradeFiltersInterface,
    TradeSharingStore,
    tradeSharingStore,
} from '../../../ng-services/social-trading/trade-sharing.store';
import { toDateString } from '../../../utils/toDateString';
import {
    SocialTradingChannelInterface,
    SocialTradingSymbolInterface,
} from '../../../ng-services/social-trading/abstract-social-trading.store';

export class TradeSharingFiltersComponent {
    static $inject = ['$location'];

    dateFrom?: Date;
    dateTo?: Date;

    symbol?: SocialTradingSymbolInterface;
    communityUid?: string;
    trader?: number;

    filters!: SharedTradeFiltersInterface;
    onChange!: (filters: { newFilters: SharedTradeFiltersInterface }) => any;

    get community(): SocialTradingChannelInterface | null {
        return this.availableCommunities.find((c) => c.uid === this.communityUid) || null;
    }

    constructor(protected $location: ng.ILocationService) {}

    $onInit() {
        tradeSharingStore.loadFilterOptions().then(() => this.updateLocalFilters());
    }

    $onChange() {
        this.updateLocalFilters();
    }

    updateLocalFilters() {
        if (this.filters.symbol) {
            this.symbol = this.availableSymbols.find((v) => v.symbol === this.filters.symbol);
        }
        this.dateFrom = this.filters.date_lower ? new Date(this.filters.date_lower) : undefined;
        this.dateTo = this.filters.date_upper ? new Date(this.filters.date_upper) : undefined;

        type FiltersKey = keyof SharedTradeFiltersInterface;
        const keys: FiltersKey[] = ['group', 'user', 'webinar'];
        keys.forEach((key) => {
            const value = this.filters[key];

            if (value) {
                this.communityUid = TradeSharingStore.createUid(key, Number(value));
            }
        });

        if (this.filters.author) {
            this.trader = Number(this.filters.author);
        }
    }

    change() {
        const newFilters = {
            ...(this.symbol && { symbol: this.symbol.symbol }),
            ...(this.dateFrom && { date_lower: toDateString(this.dateFrom) }),
            ...(this.dateTo && { date_upper: toDateString(this.dateTo) }),
            ...(this.community && this.community.entry === 'group' && { group: this.community.entry_id }),
            ...(this.community && this.community.entry === 'user' && { user: this.community.entry_id }),
            ...(this.community && this.community.entry === 'webinar' && { webinar: this.community.entry_id }),
            ...(this.trader && { author: this.trader }),
        };
        this.onChange && this.onChange({ newFilters });
    }

    get maxDate() {
        return moment().format('YYYY-MM-DD');
    }

    get availableSymbols() {
        return tradeSharingStore.symbols;
    }

    get availableCommunities() {
        return tradeSharingStore.channels;
    }

    get availableTraders() {
        return tradeSharingStore.authors;
    }
}

angular.module('tradersyard').component('tyTradeSharingFilters', {
    bindings: {
        filters: '<',
        onChange: '&',
    },
    // language=HTML
    template: `
        <ty-table-filters-wrapper>
            <div is-uib mobx-autorun>
                <div class="col-lg-2 col-sm-6">
                    <div class="form-group">
                        <label for="select_symbol">Symbol</label>
                        <div class="input-group has-ui-select">
                            <ui-select allow-clear id="select_symbol" ng-model="$ctrl.symbol" ng-change="$ctrl.change()"
                                       theme="bootstrap">
                                <ui-select-match placeholder="Select symbol">
                                    {{$select.selected.symbol}}
                                </ui-select-match>
                                <ui-select-choices repeat="symbol in $ctrl.availableSymbols | filter: $select.search">
                                    <code ng-bind-html="symbol.symbol | highlight: $select.search"></code>
                                    <span ng-bind-html="symbol.symbol_name | highlight: $select.search"></span>
                                </ui-select-choices>
                            </ui-select>

                            <div class="input-group-btn">
                                <button type="button" ng-disabled="!$ctrl.symbol"
                                        ng-click="$ctrl.symbol = undefined; $ctrl.change()" class="btn btn-default">
                                    <i class="fa fa-times"></i>
                                </button>
                            </div>

                        </div>
                    </div>
                </div>
                <div class="col-lg-3 col-sm-6" ng-if="$ctrl.availableCommunities.length" mobx-autorun>
                    <div class="form-group">
                        <label for="select_community">Community</label>
                        <div class="input-group has-ui-select">
                            <ui-select allow-clear id="select_community" ng-model="$ctrl.communityUid" ng-change="$ctrl.change()"
                                       theme="bootstrap">
                                <ui-select-match placeholder="Select community">
                                    {{$select.selected.name}}
                                </ui-select-match>
                                <ui-select-choices
                                    repeat="community.uid as community in $ctrl.availableCommunities | filter: $select.search">
                                    <span ng-bind-html="community.name | highlight: $select.search"></span>
                                </ui-select-choices>
                            </ui-select>

                            <div class="input-group-btn">
                                <button type="button" ng-disabled="!$ctrl.community"
                                        ng-click="$ctrl.communityUid = undefined; $ctrl.change()" class="btn btn-default">
                                    <i class="fa fa-times"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-3 col-sm-6" ng-if="$ctrl.availableTraders.length" mobx-autorun>
                    <div class="form-group">
                        <label for="select_trader">Trader</label>
                        <div class="input-group has-ui-select">
                            <ui-select allow-clear id="select_trader" ng-model="$ctrl.trader" ng-change="$ctrl.change()"
                                       theme="bootstrap">
                                <ui-select-match placeholder="Select trader">
                                    {{$select.selected.name}}
                                </ui-select-match>
                                <ui-select-choices repeat="trader.id as trader in $ctrl.availableTraders | filter: $select.search">
                                    <span ng-bind-html="trader.name | highlight: $select.search"></span>
                                </ui-select-choices>
                            </ui-select>

                            <div class="input-group-btn">
                                <button type="button" ng-disabled="!$ctrl.trader"
                                        ng-click="$ctrl.trader = undefined; $ctrl.change()" class="btn btn-default">
                                    <i class="fa fa-times"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-2 col-sm-6">
                    <div class="form-group">
                        <label for="date_from">From</label>
                        <div class="date_input_with_addon">
                            <input
                                type="date"
                                class="form-control"
                                id="date_from"
                                ng-model-options="{debounce: 200}"
                                ng-model="$ctrl.dateFrom"
                                ng-change="$ctrl.change()"
                                placeholder="Date from"
                                max="{{$ctrl.maxDate}}"
                            />
                            <button class="btn btn-default" ng-disabled="!$ctrl.dateFrom" ng-click="$ctrl.dateFrom = ''; $ctrl.change()">
                                <i class="fa fa-times"></i>
                            </button>
                        </div>
                    </div>
                </div>
                <div class="col-lg-2 col-sm-6">
                    <div class="form-group">
                        <label for="date_to">To</label>
                        <div class="date_input_with_addon">
                            <input
                                type="date"
                                class="form-control"
                                id="date_to"
                                ng-model-options="{debounce: 200}"
                                ng-model="$ctrl.dateTo"
                                ng-change="$ctrl.change()"
                                placeholder="Date to"
                                max="{{$ctrl.maxDate}}"
                            />
                            <button class="btn btn-default" ng-disabled="!$ctrl.dateTo"
                                    ng-click="$ctrl.dateTo = ''; $ctrl.change()">
                                <i class="fa fa-times"></i>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </ty-table-filters-wrapper>
    `,
    controller: TradeSharingFiltersComponent,
});
